/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModalConfirmation } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { structuredAnalysisTypes } from 'common/constants/StructuredAnalysisTypes';
import {
  getCommentPanelOpened,
  getComments,
  getEntityType,
  getHasCommentSelection,
  getOpenNewInlineCommentThread,
  getViewingStatus,
  resolveAllCommentsThunk,
  setCommentPanelOpened,
  setCommentPanelRendered,
  viewUnresolvedComments,
} from 'features/comments/commentsSlice';
import EnableForProjectState from 'features/security/EnableForProjectState';
import Versioning from 'features/versioning/mfe/Versioning';
import {
  useEffect,
  useRef,
  useState,
  useCallback,
  useLayoutEffect,
} from 'react';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import {
  isReportLivePreview,
  isLiveReportPreviewEnabled,
  isInlineCommentingEnabled,
} from 'common/helpers/featureFlags';
import {
  CommentEventType,
  useEventHub,
  useEventSubscription,
} from '@pwc/event-hub-ui';
import { COMMENT_VIEWING_STATUS } from 'features/comments/constants';
import CommentingListMFE from 'features/commenting/commentingList';
import { useGetCurrentUser } from 'common/hooks/useGetCurrentUser';
import { UserUtilities } from '@pwc/pwc-deals-web-common';
import ReportPreview from '@pwc/pwc-deals-report-ui/build/components/ReportPreview';
import LiveReportPreview from 'features/liveReportPreview';
import PreviewPanelHeader from '../PreviewPanel/PreviewPanelHeader';
import { PreviewErrorBoundary } from '../PreviewPanel/PreviewErrorBoundary';
import VersioningPanelHeader from '../VersioningPanel/VersioningPanelHeader';
import './RibbonPanel.scss';
import PageLevelCommentPanel from './PageLevelCommentPanel';

import CommentPanelHeader from '../CommentPanel/CommentPanelHeader';
import { RibbonButtonTypeProps } from '../CommentPanel/RibbonPanelButton';

type Props = {
  projectId: number;
  ribbonItem: string | null;
  onClose: () => void;
};

// TODO typed EnableForProjectState
type EnableForProjectStateProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  isProjectDisabled: boolean;
};

const RibbonPanel = ({
  projectId,
  ribbonItem,
  onClose,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const errorHandler = useRef({
    errorHandler: () => {
      /**/
    },
    clearError: () => {
      /**/
    },
  });
  const { eventHub } = useEventHub();
  const commentPanelOpened = useSelector(getCommentPanelOpened) as boolean;
  const viewingStatus = useSelector(getViewingStatus) as
    | 'unresolved'
    | 'resolved';

  const [showResolveAllModal, setShowResolveAllModal] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  const entityType = useSelector(getEntityType) as string;

  const location = useLocation();
  const isStructureAnalysis = useCallback(() => {
    return Object.values(structuredAnalysisTypes).some((x) => {
      return location.pathname.indexOf(x) > -1;
    });
  }, [location]);

  const isLRPEnabled = isLiveReportPreviewEnabled && !isStructureAnalysis();

  const handleResolveAllClick = () => {
    setShowResolveAllModal(true);
  };

  const resolveAllModalContent = (
    <>
      <h2>Mark all comments as resolved?</h2>
      <p>
        This will resolve all comments on this content page. You can re-open
        them separately.
      </p>
    </>
  );

  const closeConfig = {
    text: 'Cancel',
    onClick: () => {
      setShowResolveAllModal(false);
    },
  };

  const submitConfig = {
    text: 'Yes, resolve all',
    onClick: () => {
      dispatch(resolveAllCommentsThunk());
      setShowResolveAllModal(false);
    },
  };

  const commentClassName = classnames(
    'comment-panel-container',
    `comment-panel-${commentPanelOpened ? 'open' : 'closed'}`,
    `comment-panel-${viewingStatus}`,
    `comment-panel-${entityType === 'project' ? 'non-editable' : 'editable'}`,
    `${isReportLivePreview ? 'ribbon-panel-container' : ''}`,
    `${isReportLivePreview && !commentPanelOpened ? 'ribbon-panel' : ''}`
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      errorHandler.current.clearError();
    }, 5000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorHandler]);

  // TODO typed selectors
  const openNewInlineCommentThread = useSelector(getOpenNewInlineCommentThread);

  // TODO fix this
  useLayoutEffect(() => {
    dispatch(setCommentPanelRendered(true));

    return () => {
      dispatch(setCommentPanelRendered(false));
    };
  }, [dispatch, eventHub, openNewInlineCommentThread]);

  useEffect(() => {
    if (openNewInlineCommentThread) {
      eventHub?.publish(
        'content-add-comment-thread',
        openNewInlineCommentThread
      );
    }
  }, [eventHub, openNewInlineCommentThread]);

  const [commentsThread, setCommentsThread] = useState([]);
  const hasCommentSelection = useSelector(getHasCommentSelection) as boolean;

  const subscription = useCallback(({ data: { commentThreads } }) => {
    setCommentsThread(commentThreads);
  }, []);

  useEventSubscription(
    '@comment-set-comment-threads' as CommentEventType,
    subscription
  );

  const { isEntitySharedWithClient } = useSelector(getComments);

  const currentUser = useGetCurrentUser();
  const currentUserIsPractitioner = UserUtilities.isPractitioner(
    currentUser,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    projectId
  );
  const clientLabel = currentUserIsPractitioner
    ? t('clientComments')
    : t('comments');

  const commentCountLabel = isEntitySharedWithClient
    ? clientLabel
    : t('pwCComments');

  const handlePanelButtonClick = ({ type }: RibbonButtonTypeProps) => {
    if (type === 'comment') {
      if (viewingStatus !== COMMENT_VIEWING_STATUS.UNRESOLVED) {
        dispatch(viewUnresolvedComments());
      }
    } else if (type === 'preview') {
      // TODO: show live preview content
    }

    dispatch(setCommentPanelOpened(!commentPanelOpened));
  };

  return (
    <>
      <ModalConfirmation
        data-testid="resolve-all-modal"
        size="xl"
        show={showResolveAllModal}
        body={resolveAllModalContent}
        closeConfig={closeConfig}
        submitConfig={submitConfig}
        title={undefined}
      />

      <EnableForProjectState projectId={projectId}>
        {({ isProjectDisabled }: EnableForProjectStateProps) => {
          return (
            <div
              className={commentClassName}
              data-testid="comment-panel-container"
            >
              <Helmet>
                <body data-comments={commentPanelOpened ? 'open' : 'closed'} />
              </Helmet>

              {ribbonItem === 'comment' && !isInlineCommentingEnabled && (
                <div>
                  <PageLevelCommentPanel
                    projectId={projectId}
                    isProjectDisabled={isProjectDisabled}
                    onClose={onClose}
                    handleResolveAllClick={handleResolveAllClick}
                  />
                </div>
              )}

              {/* Eagerly load inlinecommenting to prevent event issues */}
              {isInlineCommentingEnabled && (
                <div
                  className={classnames(
                    `inline-commenting-panel-${
                      ribbonItem === 'comment' && commentPanelOpened
                        ? 'open'
                        : 'closed'
                    }`
                  )}
                >
                  {!isStructureAnalysis() && (
                    <>
                      <CommentPanelHeader
                        commentPanelOpened={commentPanelOpened}
                        commentCountLabel={commentCountLabel}
                        totalCommentsRendered={commentsThread.length}
                        hasCommentSelection={hasCommentSelection}
                        handlePanelButtonClick={(type) =>
                          handlePanelButtonClick(type)
                        }
                        onClose={onClose}
                      />
                      <div className="ribbon-panel-scroll">
                        <CommentingListMFE />
                      </div>
                    </>
                  )}
                </div>
              )}

              {ribbonItem === 'comment' && isInlineCommentingEnabled && (
                <div>
                  {isStructureAnalysis() && (
                    <PageLevelCommentPanel
                      projectId={projectId}
                      isProjectDisabled={isProjectDisabled}
                      onClose={onClose}
                      handleResolveAllClick={handleResolveAllClick}
                    />
                  )}
                </div>
              )}
              {ribbonItem === 'versioning' && (
                <div>
                  <VersioningPanelHeader
                    isPanelOpened={commentPanelOpened}
                    onClose={onClose}
                  />
                  <div className="ribbon-panel-scroll">
                    <Versioning />
                  </div>
                </div>
              )}

              {ribbonItem === 'preview' && (
                <div className="preview-panel-container">
                  <PreviewPanelHeader
                    isPanelOpened={commentPanelOpened}
                    onClose={onClose}
                  />
                  <div className="ribbon-panel-scroll">
                    {isLRPEnabled && <LiveReportPreview />}
                    {!isLRPEnabled && (
                      <PreviewErrorBoundary errorHandler={errorHandler.current}>
                        <ReportPreview errorHandlerRef={errorHandler.current} />
                      </PreviewErrorBoundary>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        }}
      </EnableForProjectState>
    </>
  );
};

export default RibbonPanel;
